import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import './scss/customized/utils.scss';
import './scss/customized/selectionSearch.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Access = React.lazy(() => import('./views/Access'));
const AccessDenied = React.lazy(() => import('./views/AccessDenied'));

const Login = React.lazy(() => import('./components/defaultCoreUI/pages/login/Login'));
const Register = React.lazy(() => import('./components/defaultCoreUI/pages/register/Register'));
const Page404 = React.lazy(() => import('./components/defaultCoreUI/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./components/defaultCoreUI/pages/page500/Page500'));

class App extends Component {

  render() {
    return (
      <HashRouter>
          <React.Suspense fallback={loading}>
            <Switch>
              <Route exact path="/acesso" name="Access" render={props => <Access {...props}/>} />
              <Route exact path="/acesso-negado" name="AccessDenied" render={props => <AccessDenied {...props}/>} />

              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <Route path="/" name="Home" render={props => <TheLayout {...props}/>} />
            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
